const primaryFontFamily = 'Roboto';
const primaryColor = 'rgba(0, 51, 102, 1)'; // Deep, cool blue for primary text
const secondaryColor = 'rgba(102, 153, 153, 1)'; // Muted teal for secondary text
const backgroundColor = 'rgb(245, 245, 245)'; // Light gray for a frosty backdrop
const borderColor = 'rgba(192, 192, 192, 1)'; // Light silver for borders
const buttonBackgroundColor = 'rgb(0, 102, 204)'; // Bright, icy blue for buttons
const buttonTextColor = 'rgb(255, 255, 255)'; // Crisp white for button text

const theme = {
  headline: {
    fontFamily: primaryFontFamily,
    color: primaryColor,
  },
  text: {
    fontFamily: primaryFontFamily,
    color: secondaryColor,
  },
  spacer: {
    color: 'rgba(0, 0, 0, 0)', // Transparent
  },
  button: {
    fontFamily: primaryFontFamily,
    color: buttonTextColor,
    borderColor: borderColor,
    backgroundColor: buttonBackgroundColor,
  },
  rank: {
    fontFamily: primaryFontFamily,
    baseColor: borderColor,
  },
  image: {
    backgroundColor: 'rgba(0, 0, 0, 0)', // Transparent
  },
  field: {
    fontFamily: primaryFontFamily,
    color: secondaryColor,
    borderColor: borderColor,
    backgroundColor: backgroundColor,
  },
  social: {
    color: secondaryColor,
  },
  survey: {
    fontFamily: primaryFontFamily,
    color: secondaryColor,
    borderColor: borderColor,
    backgroundColor: backgroundColor,
  },
  wheel: {
    fontFamily: primaryFontFamily,
    color: primaryColor,
    borderColor: borderColor,
    backgroundColor: backgroundColor,
    secondaryBackgroundColor: 'rgb(232, 232, 232)', // Slightly darker gray for contrast
  },
  voucher: {
    fontFamily: primaryFontFamily,
    color: secondaryColor,
    borderColor: borderColor,
  },
  checkbox: {
    color: primaryColor,
    borderColor: borderColor,
    checkboxColor: buttonBackgroundColor,
    backgroundColor: backgroundColor,
  },
};

export const mainColors = {
  primaryColor,
  secondaryColor,
  backgroundColor,
  borderColor,
};

export default {
  theme,
  mainColors,
};
